import BreadCrumbs from '@/_application/core/components/ui/breadcrumbs/breadcrumbs';
import BreadCrumbSeoSchema from '@/_application/core/components/seo/bread-crumb-seo-schema';
import {convertDataToBreadCrumbs} from '@/_application/modules/categories/models/bread-crumbs';
import {Breadcrumb} from '@/__generated__/__types__';
import {getBreadCrumsByCategory} from '@/_application/modules/products/helpers/product-bread-crumbs';

interface IProps {
    categoryName: string;
    categoryUrl?: string;
    breadCrumbItems?: Breadcrumb[];
}

const CategoryBreadCrumbs = ({categoryName, categoryUrl, breadCrumbItems = []}: Readonly<IProps>) => {
    const breadCrumbs = getBreadCrumsByCategory(categoryName, categoryUrl ?? '', breadCrumbItems);

    if (!breadCrumbs?.categoryBreadCrumbs) {
        return <></>;
    }

    return <BreadCrumbs items={breadCrumbs?.categoryBreadCrumbs} />;
};

export default CategoryBreadCrumbs;
